import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from '../../../ingredients/services';
import { MenuCreateDishSelectPage } from '../menu-create-dish-select/menu-create-dish-select';
import { MenuServices } from '../../services';
import { MenuCreatePricenextrasPage } from '../menu-create-pricenextras/menu-create-pricenextras';
import { Globals } from '../../../../globals';
import { CartaMenuViewPage } from '../../../cartas-menus/carta-menu-view/carta-menu-view';
import { AnalyticsServices } from '../../../services/analyticsServices';


/**
 * Generated class for the DishCreateFinishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-finish-section',
  templateUrl: 'menu-create-finish-section.html',
})
export class MenuCreateFinishSectionPage {

  type: any;
  section_index: any;
  section: any;
  update_state: boolean = false;
  menu_uid: string;
  show_prices: boolean;
  new_menu: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public menuServices: MenuServices,
    public globals: Globals,
    private analyticsServices: AnalyticsServices) {

    this.type = this.navParams.get('type'); //Menu style
    this.section_index = this.navParams.get('section'); //Section index number
    this.update_state = this.navParams.get('update');//Update state
    this.menu_uid = this.navParams.get('menu_uid');//Menu uid
    this.section = this.navParams.get('section'); //Section index number
    this.show_prices = this.navParams.get('show_prices');
    this.new_menu = this.navParams.get('new_menu');
  }


  openNextSection() {
    if (this.type === 'freestyle') {
      this.navCtrl.push(MenuCreateDishSelectPage, {
        type: "freestyle",
        section: this.section_index,
        update: this.update_state,
        menu_uid: this.menu_uid,
        new_menu: this.new_menu,
      });
    } else {
      this.navCtrl.push(MenuCreateDishSelectPage, {
        type: "combo",
        section: this.section_index,
        update: this.update_state,
        menu_uid: this.menu_uid,
        new_menu: this.new_menu,
      });

    }

  }

  finish() {
    this.globals.GAtrackView('Menu', 'Menu - Section - Create', this.globals.restaurant.email, 'Create/Update', 'Create section', 'Menu', '');
    this.updateFirestore(); //Guardamos secciones en Firestore
    if (this.new_menu == true) {
      this.analyticsServices.trackingExp('finisher', this.globals.tracking_exp['finisher'], '');
      //save plg_cartamenu_finisher true
      this.menuServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        plg_cartamenu_finisher: true
      });
      this.globals.restaurant.plg_cartamenu_finisher = true;
    }
    if (this.show_prices == undefined || this.show_prices == true) {
      this.goToPriceExtras();
    } else {
      this.navCtrl.setRoot(CartaMenuViewPage, {
        type: 'menu',
        state: 'edit',
        uid_element: this.menu_uid
      });
    }
  }

  updateFirestore() {
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'sections': this.menuServices.menu_section_array_complete_tmp,
      'style': this.type
    }).then(() => {
    });
  }

  goToPriceExtras() {

    this.navCtrl.push(MenuCreatePricenextrasPage, {
      update: false,
      menu_uid: this.menu_uid,
      price: 0,
      price_takeaway: 0,
      extra_price: 0,
      type: this.type,
    });


  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-finish-section/menu-create-finish-section.ts